<template>
  <!-- 第一层弹窗 -->
  <el-dialog title="资源资产流转审批" append-to-body :visible.sync="dialogVisible3" width="80%" :before-close="handleClose3">
    <div class="Approve">
      <!-- <h3>资源资产流转审批</h3> -->
      <!-- 列表搜索条件， -->
      <el-form :inline="true">
        <el-form-item label="成交时间：">
          <el-date-picker v-model="form.startTime" placeholder="选择开始日期" value-format="yyyy-MM-dd" clearable>
          </el-date-picker>
          至
          <el-date-picker v-model="form.endTime" placeholder="选择结束日期" align="right" value-format="yyyy-MM-dd" clearable>
          </el-date-picker>
        </el-form-item>
        <el-form-item label="流出方">
          <el-input style="width: 190px" v-model="form.crf" placeholder="请输入">
          </el-input>
        </el-form-item>

        <!-- <el-form-item label="交易类型">
    <el-select style="width: 190px" v-model="form.cqlxbh">
      <el-option
        v-for="item in typeOptions"
        :key="item.label"
        :label="item.label"
        :value="item.value"
      ></el-option>
    </el-select>
  </el-form-item> -->
        <!-- <el-form-item label="审批号">
    <el-input
      style="width: 190px"
      v-model="form.processNumber"
      placeholder="请输入"
    >
    </el-input>
  </el-form-item> -->
        <div class="button" style="display: inline-block; margin: 0">
          <el-form-item>
            <el-button class="query-btn" type="primary" @click="search">查询</el-button>
            <el-button class="query-btn" type="primary" @click="clear">清空</el-button>
            <!-- <el-button class="query-btn" type="primary" @click="query"
        >下载年度流转审批表</el-button
      >
      <el-button class="query-btn" type="primary" @click="clear"
        >下载本年度补贴公告公示</el-button
      > -->
          </el-form-item>
        </div>
      </el-form>
      <div class="tools" style="margin-bottom:10px">
        <el-button type="success" @click="submitApproval()">提交审批</el-button>
      </div>
      <div class="table-content">
        <table-page ref="approvalTable" :isShow="isShow" :data="approvalVoList" :defaultSelectList="defaultSelectList"
          :columns="columns" :currentPage="query.pnum" :pageSize="query.psize" :total="total" :loading="loading"
          :border="true" @selectionChange="handleSelection" @handSelectAll="handSelectAll"  @sizeChange="handleSizeChange"
          @currentChange="handleCurrentChange" @handSelect="handSelect">
          <template slot="xmmc" slot-scope="scope">
            <span @click="showDetail(scope.row.xmbh)" style="color: blue">{{
              scope.row.xmmc
              }}</span>
          </template>
          <template slot="lznx" slot-scope="scope">
            <span>{{ scope.row.lznx }}年</span>
          </template>
          <template slot="flowAreaMu" slot-scope="scope">
            <span>{{ scope.row.flowAreaMu }}亩</span>
          </template>
          <template slot="cjzj" slot-scope="scope">
            <span>{{ formatCjzj(scope.row.cjzj) }}</span>
          </template>
        </table-page>
      </div>

      <!-- 第二层弹窗  z-index="1000"-->
      <el-dialog append-to-body width="80%" title="如下资源资产交易记录缺少合同归档文件，请上传完成后在提交审批" :visible.sync="outerVisible">
        <!-- 没有集体负责人的  -->
        <div v-if="tableData2.length" style="margin-top: 20px; margin-bottom: 10px; color: red">
          以下地区村集体经济组织暂未认证，请补充村集体负责任人电话或删除对应项目审批！
        </div>
        <TablePageTwo v-if="tableData2.length" :data="tableData2" :columns="columns2" :currentPage="query2.pnum2"
          :pageSize="query2.psize2" :total="total2" :loading="loading2" :border="true">
          <template slot="xmbh" slot-scope="scope">
            <span v-for="(item, index) in scope.row.list" :key="index">
              {{ item.xmbh }}
            </span>
          </template>
          <template slot="xmdz" slot-scope="scope">
            <span>
              {{ scope.row.list.length > 0 ? scope.row.list[0].xmdz : "" }}
            </span>
          </template>
          <template slot="xmmc" slot-scope="scope">
            <span style="color: blue" v-for="(item, index) in scope.row.list" :key="index"
              @click="showDetail(item.xmbh)">
              {{ item.xmmc }} <br />
            </span>
          </template>
          <template slot="operation" slot-scope="scope">
            <el-button type="text" size="small" @click="noUp(scope.row)">
              <el-button type="primary">{{
                scope.row.operation ? "已取消" : "暂不提交"
                }}</el-button></el-button>
          </template>
          <template slot="phone" slot-scope="scope">
            <el-input @input="changePhone(scope.row)" v-model="scope.row.phone" :disabled="scope.row.operation"
              placeholder="请输入手机号"></el-input>
            <span style="color: red">{{ scope.row.validateTip }}</span>
          </template>
        </TablePageTwo>
        <div v-if="tableData3.length" style="margin-top: 20px; margin-bottom: 10px; color: red">
          以下资源资产流转缺少合同归档文件，请补充后提交审批！
        </div>
        <!-- 有集体负责人的 -->
        <TablePageTwo v-if="tableData3.length" :data="tableData3" :columns="columns3" :currentPage="query3.pnum"
          :pageSize="query3.psize" :total="total2" :loading="loading2" :border="true">
          <template slot="xmmc" slot-scope="scope">
            <span @click="showDetail(scope.row.xmbh)" style="color: blue">{{
              scope.row.xmmc
              }}</span>
          </template>
          <template slot="flowAreaMu" slot-scope="scope">
            <span>{{ scope.row.flowAreaMu }}亩</span>
          </template>
          <template slot="cjzj" slot-scope="scope">
            <span>{{ scope.row.cjzj }}元</span>
          </template>
          <template slot="lznx" slot-scope="scope">
            <span>{{ scope.row.lznx }}年</span>
          </template>
          <template slot="operation" slot-scope="scope">
            <el-button v-if="!scope.row.operation" type="primary" size="small"
              @click="upLook(scope.row)">上传合同照片</el-button>
            <el-button type="primary" size="small" @click="noPut(scope.row)">{{
              scope.row.operation ? "已取消" : "暂不提交"
              }}</el-button>
          </template>
        </TablePageTwo>
        <!-- 第三层弹窗  z-index="9999999"-->
        <el-dialog append-to-body title="合同照片上传" :visible.sync="innerVisible">
          <!-- 图片上传 -->
          <el-upload class="upload-demo" ref="AvatarUpload" action=""
            :accept="'.jpg, .JPG, .png, .PNG, .jpeg, .JPEG, WebP, .pdf'" list-type="picture-card" :auto-upload="false"
            :file-list="fileList" :on-change="upLoadImg" multiple>
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{ file }">
              <el-image ref="preview" style="height: 115px" class="el-upload-list__item-thumbnail" :src="file.url"
                :preview-src-list="innerTableList" alt="" :initial-index="BigImgIndex" />
              <span>{{ file.name }}</span>
              <span class="el-upload-list__item-actions">
                <span v-if="!file.isShow" class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span class="el-upload-list__item-delete" @click="handleDownload(file)">
                  <i class="el-icon-download"></i>
                </span>
                <span class="el-upload-list__item-delete" @click="handleRemove(file)">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
          <div slot="footer" class="dialog-footer">
            <el-button style="margin-top: 20px" @click="back">关闭</el-button>
            <el-button :loading="loadingwxf" type="primary" @click="submit()">{{
              loadingwxf ? "上传中..." : "保存"
              }}</el-button>
          </div>
        </el-dialog>
        <div slot="footer" class="dialog-footer">
          <el-button @click="outerVisible = false">关闭</el-button>
          <el-button type="primary" @click="again()">提交审批</el-button>
        </div>
      </el-dialog>
      <!-- 第三层弹窗 -->
      <el-dialog title="文件上传" :visible.sync="dialogVisible" width="90%" :before-close="handleClose" append-to-body>
        <!-- 耕地流转意向书 -->
        <div class="upload-tit">
          <div class="file-title">
            <i class="el-icon-document" style="color: #3B82F6"></i>
            <span class="title-text">耕地流转意向书</span>
          </div>
        </div>

        <div class="upload-container">
          <!-- 流转意向书-->
          <el-card class="file-card" shadow="hover" v-for="(item, index) in defaultSelectList" :key="index">
            <!-- 意向书 -->
            <el-row class="file-item">
              <el-col :span="18">
                <div class="file-name">
                  <span class="file-title-text">{{ item.xmmc }}</span>
                  <span class="file-title-text">流转意向书<span style="color:red">*</span></span>
                </div>
                <div class="Imgbox" v-if="submitApprovalDto.xmbhList[index].transferIntentionAgreement.length">
                  <div class="imageBox"
                    v-for="(its, ind) in submitApprovalDto.xmbhList[index].transferIntentionAgreement" :key="ind">
                    <div class="deleteBtn" @click="deleteBtn(ind, index, '0')">
                      X
                    </div>
                    <el-image style="width: 100px; height: 100px; " :initial-index="ind" :preview-src-list="changeFile(submitApprovalDto.xmbhList[index].transferIntentionAgreement)"
                      :src="'/api/admin/file/get?ossFilePath=' + its.url"></el-image>
                  </div>
                </div>

              </el-col>
              <el-col :span="6" align="right">
                <el-upload class="upload-demo" action="action" ref="uploadIntention" :file-list="fileList"
                  :multiple="true" :show-file-list="false" :auto-upload="false" :on-change="handleChange">
                  <el-button  type="primary" icon="el-icon-upload" size="small"
                    @click="uploadFile(item, index, '0')">上传文件</el-button>
                </el-upload>

              </el-col>
            </el-row>
            <!-- 委托书 -->
            <el-row class="file-item">
              <el-col :span="18">
                <div class="file-name">
                  <span class="file-title-text">委托流转书面委托书</span>
                  <span class="file-note">(涉及委托流转需提供)</span>
                </div>
                <!-- <div class="Imgbox" v-if="submitApprovalDto.xmbhList[index].transferEntrustment.length">
                  <el-image v-for="(its,ind) in submitApprovalDto.xmbhList[index].transferEntrustment" :key="ind"
                    style="width: 100px; height: 100px" :src="'/api/admin/file/get?ossFilePath='+its.url"></el-image>
                </div> -->
                <div class="Imgbox" v-if="submitApprovalDto.xmbhList[index].transferEntrustment.length">
                  <div class="imageBox" v-for="(its, ind) in submitApprovalDto.xmbhList[index].transferEntrustment"
                    :key="ind">
                    <div class="deleteBtn" @click="deleteBtn(ind, index, '1')">
                      X
                    </div>
                    <el-image style="width: 100px; height: 100px; "  :initial-index="ind" :preview-src-list="changeFile(submitApprovalDto.xmbhList[index].transferEntrustment)"
                      :src="'/api/admin/file/get?ossFilePath=' + its.url"></el-image>
                  </div>
                </div>
              </el-col>
              <el-col :span="6" align="right">
                <el-upload class="upload-demo" action="action" ref="uploadIntention" :file-list="fileList"
                  :show-file-list="false" :auto-upload="false" :on-change="handleChange" :multiple="true">
                  <el-button  type="primary" icon="el-icon-upload" size="small"
                    @click="uploadFile(item, index, '1')">上传文件</el-button>
                </el-upload>
              </el-col>
            </el-row>
            <!-- 会议纪要 -->
            <el-row class="file-item">
              <el-col :span="18">
                <div class="file-name">
                  <span class="file-title-text">集体经济组织成员大会会议纪要</span>
                  <span class="file-note">(涉及未承包到户集体土地，需提供)</span>
                </div>
                <!-- <div class="Imgbox" v-if="submitApprovalDto.xmbhList[index].meetingMinutes.length">
                  <el-image v-for="(its,ind) in submitApprovalDto.xmbhList[index].meetingMinutes" :key="ind"
                    style="width: 100px; height: 100px" :src="'/api/admin/file/get?ossFilePath='+its.url"></el-image>
                </div> -->
                <div class="Imgbox" v-if="submitApprovalDto.xmbhList[index].meetingMinutes.length">
                  <div class="imageBox" v-for="(its, ind) in submitApprovalDto.xmbhList[index].meetingMinutes"
                    :key="ind">
                    <div class="deleteBtn" @click="deleteBtn(ind, index, '2')">
                      X
                    </div>
                    <el-image style="width: 100px; height: 100px; "
                    :initial-index="ind" :preview-src-list="changeFile(submitApprovalDto.xmbhList[index].meetingMinutes)"
                      :src="'/api/admin/file/get?ossFilePath=' + its.url"></el-image>
                  </div>
                </div>
              </el-col>
              <el-col :span="6" align="right">
                <el-upload class="upload-demo" action="action" ref="uploadIntention" :file-list="fileList"
                  :show-file-list="false" :auto-upload="false" :on-change="handleChange" :multiple="true">
                  <el-button  type="primary" icon="el-icon-upload" size="small"
                    @click="uploadFile(item, index, '2')">上传文件</el-button>
                </el-upload>
              </el-col>
            </el-row>
          </el-card>


          <!-- 其他文件 -->
          <div class="upload-tit">
            <div class="file-title">
              <!-- <i class="el-icon-document" style="color: #3B82F6"></i> -->
              <span class="title-text">其他文件</span>
            </div>
          </div>

          <!-- 文件分区 2 -->
          <el-card class="file-card" shadow="hover" mt-20>

            <!-- 营业执照或法人资格证明-->
            <el-row class="file-item">
              <el-col :span="18">
                <div class="file-name">
                  <span class="file-title-text">营业执照或法人资格证明 <span style="color:red">*</span></span>
                </div>
                <div class="Imgbox" v-if="submitApprovalDto.qualificationCertificate.length">
                  <div class="imageBox" v-for="(its, ind) in submitApprovalDto.qualificationCertificate" :key="ind">
                    <div class="deleteBtn" @click="deleteBtn(ind, 0, '3')">
                      X
                    </div>
                    <el-image style="width: 100px; height: 100px; "   :initial-index="ind" :preview-src-list="changeFile(submitApprovalDto.qualificationCertificate)"
                      :src="'/api/admin/file/get?ossFilePath=' + its.url"></el-image>
                  </div>
                </div>
              </el-col>
              <el-col :span="6" align="right">
                <!-- <el-button type="primary" icon="el-icon-upload" size="small" @click="uploadFile(item)">上传</el-button> -->
                <el-upload class="upload-demo" action="action" ref="uploadIntention" :file-list="fileList"
                  :show-file-list="false" :auto-upload="false" :on-change="handleChange" :multiple="true">
                  <el-button  type="primary" icon="el-icon-upload" size="small"
                    @click="uploadFile(0, 0, '3')">上传文件</el-button>
                </el-upload>
              </el-col>
            </el-row>
            <!-- 自然人有效身份证证明 -->
            <el-row class="file-item">
              <el-col :span="18">
                <div class="file-name">
                  <span class="file-title-text">自然人有效身份证证明 <span style="color:red">*</span></span>
                </div>
                <div class="Imgbox" v-if="submitApprovalDto.proofOfIdentity.length">
                  <div class="imageBox" v-for="(its, ind) in submitApprovalDto.proofOfIdentity" :key="ind">
                    <div class="deleteBtn" @click="deleteBtn(ind, 0, '8')">
                      X
                    </div>
                    <el-image style="width: 100px; height: 100px; "   :initial-index="ind" :preview-src-list="changeFile(submitApprovalDto.proofOfIdentity)"
                      :src="'/api/admin/file/get?ossFilePath=' + its.url"></el-image>
                  </div>
                </div>
              </el-col>
              <el-col :span="6" align="right">
                <!-- <el-button type="primary" icon="el-icon-upload" size="small" @click="uploadFile(item)">上传</el-button> -->
                <el-upload class="upload-demo" action="action" ref="uploadIntention" :file-list="fileList"
                  :show-file-list="false" :auto-upload="false" :on-change="handleChange" :multiple="true">
                  <el-button  type="primary" icon="el-icon-upload" size="small"
                    @click="uploadFile(0, 0, '8')">上传文件</el-button>
                </el-upload>
              </el-col>
            </el-row>
            <!-- 信用报告creditReport -->
            <el-row class="file-item">
              <el-col :span="18">
                <div class="file-name">
                  <span class="file-title-text">资信证明和信用报告，自然人个人信用报告 <span style="color:red">*</span></span>
                </div>
                <!-- <div class="Imgbox" v-if="submitApprovalDto.creditReport.length">
                  <el-image v-for="(its,ind) in submitApprovalDto.creditReport" :key="ind"
                    style="width: 100px; height: 100px" :src="'/api/admin/file/get?ossFilePath='+its.url"></el-image>
                </div> -->
                <div class="Imgbox" v-if="submitApprovalDto.creditReport.length">
                  <div class="imageBox" v-for="(its, ind) in submitApprovalDto.creditReport" :key="ind">
                    <div class="deleteBtn" @click="deleteBtn(ind, 0, '4')">
                      X
                    </div>
                    <el-image style="width: 100px; height: 100px; "   :initial-index="ind" :preview-src-list="changeFile(submitApprovalDto.creditReport)"
                      :src="'/api/admin/file/get?ossFilePath=' + its.url"></el-image>
                  </div>
                </div>
              </el-col>
              <el-col :span="6" align="right">
                <el-upload class="upload-demo" action="action" ref="uploadIntention" :file-list="fileList"
                  :show-file-list="false" :auto-upload="false" :on-change="handleChange" :multiple="true">
                  <el-button  type="primary" icon="el-icon-upload" size="small"
                    @click="uploadFile(0, 0, '4')">上传文件</el-button>
                </el-upload>
              </el-col>
            </el-row>
            <!-- 合伙人协议 partnerAgreement -->
            <el-row class="file-item">
              <el-col :span="18">
                <div class="file-name">
                  <span class="file-title-text">章程或合伙人协议 <span style="color:red">*</span></span>
                </div>
                <!-- <div class="Imgbox" v-if="submitApprovalDto.partnerAgreement.length">
                  <el-image v-for="(its,ind) in submitApprovalDto.partnerAgreement" :key="ind"
                    style="width: 100px; height: 100px" :src="'/api/admin/file/get?ossFilePath='+its.url"></el-image>
                </div> -->
                <div class="Imgbox" v-if="submitApprovalDto.partnerAgreement.length">
                  <div class="imageBox" v-for="(its, ind) in submitApprovalDto.partnerAgreement" :key="ind">
                    <div class="deleteBtn" @click="deleteBtn(ind, 0, '5')">
                      X
                    </div>
                    <el-image style="width: 100px; height: 100px; "  :initial-index="ind" :preview-src-list="changeFile(submitApprovalDto.partnerAgreement)"
                      :src="'/api/admin/file/get?ossFilePath=' + its.url"></el-image>
                  </div>
                </div>
              </el-col>
              <el-col :span="6" align="right">
                <el-upload class="upload-demo" action="action" ref="uploadIntention" :file-list="fileList"
                  :show-file-list="false" :auto-upload="false" :on-change="handleChange" :multiple="true">
                  <el-button  type="primary" icon="el-icon-upload" size="small"
                    @click="uploadFile(0, 0, '5')">上传文件</el-button>
                </el-upload>
              </el-col>
            </el-row>
            <!-- 规划书 projectPlan -->
            <el-row class="file-item">
              <el-col :span="18">
                <div class="file-name">
                  <span class="file-title-text">农业经营项目规划书 <span style="color:red">*</span></span>
                </div>
                <!-- <div class="Imgbox" v-if="submitApprovalDto.projectPlan.length">
                  <el-image v-for="(its,ind) in submitApprovalDto.projectPlan" :key="ind"
                    style="width: 100px; height: 100px" :src="'/api/admin/file/get?ossFilePath='+its.url"></el-image>
                </div> -->
                <div class="Imgbox" v-if="submitApprovalDto.projectPlan.length">
                  <div class="imageBox" v-for="(its, ind) in submitApprovalDto.projectPlan" :key="ind">
                    <div class="deleteBtn" @click="deleteBtn(ind, 0, '6')">
                      X
                    </div>
                    <el-image style="width: 100px; height: 100px; "  :initial-index="ind" :preview-src-list="changeFile(submitApprovalDto.projectPlan)"
                      :src="'/api/admin/file/get?ossFilePath=' + its.url"></el-image>
                  </div>
                </div>
              </el-col>
              <el-col :span="6" align="right">
                <el-upload class="upload-demo" action="action" ref="uploadIntention" :file-list="fileList"
                  :show-file-list="false" :auto-upload="false" :on-change="handleChange" :multiple="true">
                  <el-button  type="primary" icon="el-icon-upload" size="small"
                    @click="uploadFile(0, 0, '6')">上传文件</el-button>
                </el-upload>
              </el-col>
            </el-row>
            <!-- 资质证明 operationCapacity-->
            <el-row class="file-item">
              <el-col :span="18">
                <div class="file-name">
                  <span class="file-title-text">农业经营能力或资质的证明 <span style="color:red">*</span></span>
                  <span class="file-note">(技术团队、资金实力等)<span style="color:red">*</span></span>
                </div>
                <!-- <div class="Imgbox" v-if="submitApprovalDto.operationCapacity.length">
                  <el-image v-for="(its,ind) in submitApprovalDto.operationCapacity" :key="ind"
                    style="width: 100px; height: 100px" :src="'/api/admin/file/get?ossFilePath='+its.url"></el-image>
                </div> -->
                <div class="Imgbox" v-if="submitApprovalDto.operationCapacity.length">
                  <div class="imageBox" v-for="(its, ind) in submitApprovalDto.operationCapacity" :key="ind">
                    <div class="deleteBtn" @click="deleteBtn(ind, 0, '7')">
                      X
                    </div>
                    <el-image style="width: 100px; height: 100px; " :initial-index="ind" :preview-src-list="changeFile(submitApprovalDto.operationCapacity)"
                      :src="'/api/admin/file/get?ossFilePath=' + its.url"></el-image>
                  </div>
                </div>
              </el-col>
              <el-col :span="6" align="right">
                <el-upload class="upload-demo" action="action" ref="uploadIntention" :file-list="fileList"
                  :show-file-list="false" :auto-upload="false" :on-change="handleChange" :multiple="true">
                  <el-button  type="primary" icon="el-icon-upload" size="small"
                    @click="uploadFile(0, 0, '7')">上传文件</el-button>
                </el-upload>
              </el-col>
            </el-row>
          </el-card>
        </div>

        <!-- 底部按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="confirm">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </el-dialog>
</template>
<script>
  const Query = [
    {
      name: "title",
      label: "提交时间",
      componentType: "input",
      inputType: "",
      placeholder: "请选择",
      width: "160px",
      dataOptions: [],
    },
    {
      name: "departName",
      label: "状态：",
      componentType: "input",
      placeholder: "请选择",
      width: "140px",
      inputType: "",
      dataOptions: [],
    },

    {
      name: "status",
      label: "交易类型",
      componentType: "select",
      placeholder: "请选择",
      width: "180px",
      dataOptions: [
        {
          name: "全部",
          value: 0,
        },
        {
          name: "转让",
          value: -1,
        },
        {
          name: "出租",
          value: 1,
        },
        {
          name: "入股",
          value: 2,
        },
      ],
    },
    {
      name: "departName",
      label: "产权类型：",
      componentType: "input",
      placeholder: "请选择",
      width: "140px",
      inputType: "",
      dataOptions: [],
    },
  ];
  import { uploadFile } from "@/api/fileApi";
  // 图片下载
  import { download } from "@/api/ChargeUp";
  import { mapGetters, mapMutations } from "vuex";
  import { uploadContract, selectContractPic } from "@/api/add";
  import { selectNoApproval, insertApprovar } from "@/api/FlowApproval.js";
  import { spColumn, sqProps, sqProps2 } from "../tableColumn";
  import FormQuery from "@/components/form/form-search";
  import TablePage from "@/components/table/Approve-page";
  import TablePageTwo from "@/components/table/CallForBids-page";
  import axios from 'axios';
  const baseUrl = window.globalUrl.HOME_API;
  // 定义一个取消令牌
  let cancelTokenSource;
  export default {

    data() {
      return {
        submitApprovalDto: {
          xmbhList: [{
            transferIntentionAgreement: [],
            meetingMinutes: [],
            transferEntrustment: [],
          }
          ],
          qualificationCertificate: [],
          creditReport: [],
          partnerAgreement: [],
          projectPlan: [],
          operationCapacity: [],
          proofOfIdentity:[]
        },
        isTrue: false,//是否禁用上传按钮
        action: `${window.globalUrl.HOME_API_WEI}/admin/file/upload`, //上传图片的地址
        fileList: [],//图片请求列表
        fileList1: [],//图片请求列表

        DataType: 0,//上传的文件类型
        tableIndex: 0,//当前表格索引
        tableItem: {},//当前表格项


        // validateTip: "",//手机号校验提示语
        dialogVisible3: true,
        underApprovalList: [], //审批中的项目列表
        Query: Query,
        approvalVoList: [], //发起审批的列表所有数据的list
        approvalNowYearsList: [], //发起审批的列表本年度的list
        defaultSelectList: [], //选中的列表
        isShow: false,
        loading: false,
        loading2: false,
        loadingwxf: false,
        columns: spColumn,
        columns2: sqProps,
        columns3: sqProps2,
        keyForm: 1,
        total: 0,
        total2: 0,
        outerVisible: false,
        innerVisible: false,
        dialogVisible: false,
        baseUrl: window.globalUrl.BASE_API,
        InitObj: {},
        tabsInex: 0,
        contractPhoto: [], // 存储合同照片
        otherPhoto: [], // 存储其他材料
        innerTableList: [],
        BigImgIndex: 0,
        fileList: [],
        tableData3: [],
        tableData2: [],
        xmbhList: [], //项目编号列表
        xmbsmList: [], //项目标识码列表
        leadingOfficialList: [], //集体负责人列表
        // isSubmitting : false,//第一次提交状态
        isProcessing: false, //第二次提交状态
        form: {
          startTime: "",
          endTime: "",
          crf: "",
          // cqlxbh:''
        },
        query: {
          current: 1,
          size: 10,
        },
        query2: {
          pnum2: 1,
          psize2: 10,
        },
        query3: {
          pnum: 1,
          psize: 10,
        },

        tabsList: [
          {
            title: "合同照片",
          },
          {
            title: "其他类型",
          },
        ],

        // // 文件分区 2：其他文件
        // otherFileList: [
        //   {
        //     title: "营业执照或法人资格证明，自然人有效身份证证明",
        //     note: "",
        //     required: true,
        //   },
        //   {
        //     title: "资信证明和信用报告，自然人个人信用报告",
        //     note: "",
        //     required: true,
        //   },
        //   {
        //     title: "章程或合伙人协议",
        //     note: "",
        //     required: true,
        //   },
        //   {
        //     title: "农业经营项目规划书",
        //     note: "",
        //     required: true,
        //   },
        //   {
        //     title: "农业经营能力或资质的证明(技术团队、资金实力等)",
        //     note: "",
        //     required: true,
        //   },
        // ],

        // typeOptions: [
        //   {
        //     label: "全部",
        //     value: 'null',
        //   },
        //   {
        //     label: "资源资产备案",
        //     value: "1",
        //   },
        //   {
        //     label: "补贴申请",
        //     value: "2",
        //   },
        // ],
      };
    },
    computed: mapGetters(["identityObj"]),
    components: {
      FormQuery,
      TablePage,
      TablePageTwo,
    },
    created() {
      this.selectNoApproval();
      // console.log(this.identityObj, "查看this.identityObj");
    },
    watch: {
      innerVisible: {
        handler(newVal, oldVal) {
          console.log(newVal, "查看newVal");
          console.log(oldVal, "查看oldVal");
          if (newVal == false) {
            this.cancelUpload()
          }
        },
        deep: true,
      },
    },
    methods: {
 //分页单页切换
 handleCurrentChange(page) {
        this.query.current = page;
        this.selectNoApproval();
      },
      //分页总页数切换
      handleSizeChange(size) {
        this.query = {
          current: 1,
          size: size,
        };
        this.selectNoApproval();
      },
      // 将图片拼接成预览图
      changeFile(fileList) {
        return fileList.map(file => `${baseUrl}/admin/file/get?ossFilePath=${file.url}`);
      },
      //删除
      deleteBtn(ind, index, type) {
        let typeNumber = Number(type)
        this.$confirm('此操作将删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          switch (typeNumber) {
            case 0:
              this.submitApprovalDto.xmbhList[index].transferIntentionAgreement.splice(ind, 1)
              break;
            case 1:
              this.submitApprovalDto.xmbhList[index].transferEntrustment.splice(ind, 1)
              break;
            case 2:
              break;
              this.submitApprovalDto.xmbhList[index].meetingMinutes.splice(ind, 1)
            case 3:
              this.submitApprovalDto.qualificationCertificate.splice(ind, 1)
              break;
            case 4:
              this.submitApprovalDto.creditReport.splice(ind, 1)
              break;
            case 5:
              this.submitApprovalDto.partnerAgreement.splice(ind, 1)
              break;
            case 6:
              this.submitApprovalDto.projectPlan.splice(ind, 1)
              break;
            case 7:
              this.submitApprovalDto.operationCapacity.splice(ind, 1)
              break;
              case 8:
              this.submitApprovalDto.proofOfIdentity.splice(ind, 1)
                break
          }
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });


      },
      //关闭弹窗
      handleClose() {
        this.dialogVisible = false;
      },// 取消按钮
      cancel() {
        this.dialogVisible = false
        this.getSubmitApprovalDto()
      },
    //初始化数据
      getSubmitApprovalDto() {
        this.submitApprovalDto.xmbhList = []
        this.submitApprovalDto.qualificationCertificate = [],
          this.submitApprovalDto.creditReport = []
        this.submitApprovalDto.partnerAgreement = []
        this.submitApprovalDto.projectPlan = []
        this.submitApprovalDto.operationCapacity = []
        this.submitApprovalDto.xmbhList = []
        //定义初始值
        for (let i = 0; i < this.defaultSelectList.length; i++) {
          this.submitApprovalDto.xmbhList.push({
            transferIntentionAgreement: [], // 土地经营权流转意向协议书
            meetingMinutes: [], // 集体经济组织会议纪要
            transferEntrustment: [], // 土地流转委托书
          })
        }
      },

      handleChange(file, fileList) {
        this.isTrue = true; // 在文件选择后禁
        var formData = new FormData();
        formData.append("catalog", "ask-1");
        formData.append("file", file.raw);
        let tmpType = Number(this.DataType);
        uploadFile(formData)
          .then((res) => {
            this.isTrue = true;
            if (res && res.code == 0) {
              let name = res.data.sourceFileName
              let url = res.data.url
              let index = Number(this.tableIndex)
              let type = Number(tmpType)
              switch (type) {
                case 0:
                  this.submitApprovalDto.xmbhList[index].transferIntentionAgreement.push(
                    {
                      name: name,
                      url: url
                    }
                  )

                  this.submitApprovalDto.xmbhList[index].xmbh = this.tableItem.xmbh
                  break;
                case 1:
                  this.submitApprovalDto.xmbhList[index].transferEntrustment.push({
                    name: name,
                    url: url
                  })
                  this.submitApprovalDto.xmbhList[index].xmbh = this.tableItem.xmbh
                  break;
                case 2:
                  this.submitApprovalDto.xmbhList[index].meetingMinutes.push({
                    name: name,
                    url: url
                  })
                  this.submitApprovalDto.xmbhList[index].xmbh = this.tableItem.xmbh
                  break;
                case 3:
                  this.submitApprovalDto.qualificationCertificate.push({
                    name: name,
                    url: url
                  })
                  break;
                case 4:
                  this.submitApprovalDto.creditReport.push({
                    name: name,
                    url: url
                  })
                  break;
                case 5:
                  this.submitApprovalDto.partnerAgreement.push({
                    name: name,
                    url: url
                  })
                  break;
                case 6:
                  this.submitApprovalDto.projectPlan.push({
                    name: name,
                    url: url
                  })
                  break;
                case 7:
                  this.submitApprovalDto.operationCapacity.push({
                    name: name,
                    url: url
                  })
                  break;
                  case 8:
                  this.submitApprovalDto.proofOfIdentity.push({
                    name: name,
                    url: url
                  })
                    break

              }

              this.isTrue = false
            }
          })
      },
      //上传图片
      async uploadFile(item, index, type) {
        this.DataType = Number(type);//0代表意向书，1代表委托书，2代表会议纪要
        this.tableIndex = index
        this.tableItem = item
      },
      // 确定
      async confirm() {
        // let xmbhList = []
        let isTrue = true
        for (let i = 0; i < this.submitApprovalDto.xmbhList.length; i++) {
          if (this.submitApprovalDto.xmbhList[i].transferIntentionAgreement == 0) {
            isTrue = false;
          }
        } if (
          this.submitApprovalDto.qualificationCertificate.length == 0 ||
          this.submitApprovalDto.proofOfIdentity.length == 0||
          this.submitApprovalDto.creditReport.length == 0 ||
          this.submitApprovalDto.partnerAgreement.length == 0 ||
          this.submitApprovalDto.projectPlan.length == 0 ||
           this.submitApprovalDto.operationCapacity.length==0
        ) {
          isTrue = false;
        } else {
          isTrue = true;
        }
        // console.log(isTrue, '查看是否可以上传')

        if (isTrue) {
          let xmbsmList = []
          this.submitApprovalDto.xmbsmList = xmbsmList
          this.defaultSelectList.forEach((item) => {
            xmbsmList.push(item.xmbsm);

          });
          // 将图片转成数组传给后端

          let jsonXmbhlist = this.submitApprovalDto.xmbhList.map(item => ({
            transferIntentionAgreement: JSON.stringify(item.transferIntentionAgreement),
            meetingMinutes: JSON.stringify(item.meetingMinutes),
            transferEntrustment: JSON.stringify(item.transferEntrustment),
            xmbh: item.xmbh // 如果 xmbh 不需要转换为字符串，则直接赋值
          }));

          let newData = {
            qualificationCertificate: JSON.stringify(this.submitApprovalDto.qualificationCertificate),
            creditReport: JSON.stringify(this.submitApprovalDto.creditReport),
            partnerAgreement: JSON.stringify(this.submitApprovalDto.partnerAgreement),
            projectPlan: JSON.stringify(this.submitApprovalDto.projectPlan),
            operationCapacity: JSON.stringify(this.submitApprovalDto.operationCapacity),
            proofOfIdentity:JSON.stringify(this.submitApprovalDto.proofOfIdentity),
            xmbhList: jsonXmbhlist,
            xmbsmList: xmbsmList
          }



          // console.log(this.submitApprovalDto, "查看submitApprovalDto")

          let res = await insertApprovar(newData)
          if (res.code == 0) {
            this.submitApprovalDto = {
              xmbhList: [],
              qualificationCertificate: [],
              creditReport: [],
              partnerAgreement: [],
              projectPlan: [],
              operationCapacity: [],
              proofOfIdentity:[]
            }
            // newData = {

            // }
            this.cancel()
            this.selectNoApproval()
            // this.handleClose3()
            this.$message.success(res.msg)
          } else {
            this.$message.error(res.msg)
          }
          // this.dialogVisible = false

        } else {
          this.$message.info('请完善您的资料')
        }


      },


      //提交审批
      async submitApproval() {

        if (this.defaultSelectList) {
          this.dialogVisible = true
        } else {
          this.$message.info('请选择想要提交的审批')
        }

      },

  
      formatCjzj(cjzj) {
        try {
          if (typeof cjzj !== "number") {
            throw new TypeError("cjzj应为数字");
          }
          // 如果大于一万元，进行除以10000的处理，否则返回原值
          return cjzj > 10000
            ? (cjzj / 10000).toFixed(2) + "万元"
            : cjzj.toFixed(2) + "元";
        } catch (error) {
          console.error(error.message);
          return "0.00"; // 错误时返回默认值
        }
      },
      changePhone(row) {
        console.log(row.phone, "查看是否执行");
        if (!row.phone) {
          row.validateTip = "手机号不能为空";
        } else if (!/^1[3-9]\d{9}$/.test(row.phone)) {
          row.validateTip = "请输入有效的手机号";
        } else {
          row.validateTip = "";
        }
        console.log(row.validateTip, "查看校验的是什么");
      },
      noUp(obj) {
        console.log(obj, "查看obj");
        obj.validateTip = "";
        obj.operation = !obj.operation;
        obj.phone = "";
        if (this.tableData2.length) {
          this.outerVisible = false;
        }

        // 遍历 tableData2 中当前项的 list
        obj.list &&
          obj.list.forEach((subItem) => {
            const currentXmbh = subItem.xmbh; // 获取当前子项的项目编号

            // 更新 tableData3 中对应项目的 operation 状态
            this.tableData3.forEach((item) => {
              if (item.xmbh === currentXmbh) {
                // 检查项目编号是否相同
                item.operation = obj.operation; // 将状态与 obj.operation 反向
              }
            });
          });
        // 找到与 obj.list[0]相同对象的 list 在this.tableData2   中的下标，并删除包含此 list 的对象
        let newTable = this.tableData2.filter((item) => {
          return !item.list.some((subItem) => {
            return (
              subItem.xmbh === obj.list[0].xmbh &&
              subItem.xmdz === obj.list[0].xmdz
            );
          });
        });
        console.log(newTable, "查看newTable");
        this.tableData2 = newTable;
      },
      //不提报
      noPut(obj) {
        console.log(obj, "查看obj2");
        this.$set(obj, "operation", !obj.operation);
        console.log(obj.operation, "查看obj.operation");
        // 判断现在数据的状态
        // 取消状态删除list中的某一项，如果没有那一项之前删除整个item

        if (obj.operation) {
          //禁用状态
          console.log("执行1");
          // 遍历 tableData2
          this.tableData2 &&
            this.tableData2.forEach((item) => {
              if (item.list) {
                // 遍历当前项的 list，并删除与 obj.xmbh 相同的项
                item.list = item.list.filter(
                  (subItem) => subItem.xmbh !== obj.xmbh
                );
              } else {
              }
              // 删除对应的 item 如果 list 为空
              this.tableData2 = this.tableData2.filter(
                (item) => item.list && item.list.length > 0
              );
            });
        } else {
          //打开状态
          // 点击上传需要this.tableData2集体负责人的手机号增加此项
          console.log("执行2");
          // 是否需要添加新的对象
          let found = false;
          // 是否需要改变所需要的状态
          let state = false;

          this.tableData2 &&
            this.tableData2.forEach((item) => {
              if (item.list) {
                // 检查 item.list 中是否存在与 obj.xmdz 相同的项
                const exists = item.list.some(
                  (subItem) => subItem.xmdz === obj.xmdz
                );
                const exists2 = item.list.some(
                  (subItem) => subItem.xmbh === obj.xmbh
                );
                if (exists && !exists2) {
                  console.log("这里不能执行");
                  // 如果存在，相应的 obj 添加到当前 item.list
                  item.list.push(obj);
                  found = true; // 找到匹配项
                } else {
                  found = true;
                  //特殊情况需要把this.table2中的operation取反
                  state = true;
                }
              }
            });

          // 如果没有找到相同的 xmdz，添加一个新的对象到 this.tableData2
          if (!found) {
            const existsInLeadingOfficialList =
              this.leadingOfficialList &&
              this.leadingOfficialList.some((official) => {
                console.log(official, "查看official");
                // 检查官方列表中每个对象的 list 是否存在与 obj.xmdz 相同的项
                return (
                  official.list &&
                  official.list.some((subItem) => subItem.xzqbh === obj.xzqbh)
                );
              });
            console.log(
              existsInLeadingOfficialList,
              "查看existsInLeadingOfficialList"
            );
            // this.tableData2.push({
            //   list: [obj], // 创建一个新的 list 包含当前 obj
            //   operation: false // 设定 operation 的初始值
            // });

            if (existsInLeadingOfficialList) {
              this.tableData2.push({
                list: [obj], // 创建一个新的 list 包含当前 obj
                operation: false, // 设定 operation 的初始值
              });
            }
          }
          if (state) {
            // console.log('这里需要执行11111111111111111111')
            this.tableData2 &&
              this.tableData2.forEach((item) => {
                if (item.list) {
                  item.list = item.list.filter(
                    (subItem) => subItem.xmbh !== obj.xmbh
                  );
                  // 使用 Array.some() 来检查是否存在相等的 xmbh
                  const isHas = item.list.some(
                    (listItem) => listItem.xmbh === obj.xmbh
                  );

                  // 如果存在则更新状态
                  if (isHas) {
                    this.$set(item, "operation", obj.operation);
                  }
                }
              });
          }

          //  console.log(this.tableData2, '经过处理后的 tableData2');
        }
      },
      handleClose3() {
        this.$emit("closeDialog3", false);
      },
      handleSelection(selects) {
        console.log(selects, '单选？');
      }, // 全选或者反选
      handSelectAll(selection) {
        this.defaultSelectList = selection;
        //初始值
        this.getSubmitApprovalDto()
        console.log(selection, "全选");
      },
      //多选
      handSelect(selection) {
        this.defaultSelectList = selection;
        //初始值
        this.getSubmitApprovalDto()
        console.log(selection, "多选");
      },
      //删除
      handleRemove(file, fileList) {
        //可用版本1
        // console.log(file, fileList);
        const index = this.fileList.findIndex((item) => item.uid === file.uid);
        this.fileList.splice(index, 1);
      },
      //放大
      handlePictureCardPreview(file) {
        // console.log(file,'查看file')
        this.BigImgIndex = this.fileList.findIndex(
          (item) => item.uid === file.uid
        );
        // console.log( this.fileList,'查看fileList')
        let abc = [];
        this.fileList.forEach((its) => {
          if (!its.isShow) {
            abc.push(its.url);
          }
        });
        this.innerTableList = abc;
        this.$nextTick(() => {
          this.$refs.preview.clickHandler();
        });
      },
      //下载
      async handleDownload(file) {
        console.log("下载");
        console.log(file);
        let itemList = file;
        console.log(this.baseUrl + "admin/file/get?ossFilePath=" + itemList.url2);

        let res = await download({
          ossFilePath:
            this.baseUrl + "admin/file/get?ossFilePath=" + itemList.url2,
        });
        if (res) {
          let blob = res;
          let ToName = itemList.name;
          const fileName = ToName;
          let downloadElement = document.createElement("a");
          let binaryData = [];
          binaryData.push(blob);
          let href = window.URL.createObjectURL(
            new Blob(binaryData, {
              type: "application/pdf||doc||docx||xls||xlsx||zip||7z",
            })
          ); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = decodeURIComponent(fileName); //解码
          document.body.appendChild(downloadElement);
          downloadElement.click();
          document.body.removeChild(downloadElement);
          window.URL.revokeObjectURL(href);
        }
      },

      //清空
      clear() {
        (this.form.startTime = ""), (this.form.endTime = "");
        this.form.crf = "";
        // this.form.cqlxbh=''
        this.selectNoApproval();
      },
      //查询
      search() {
        // console.log(this.form, "查看form");
        this.selectNoApproval();
      },
      // 改变回显的样式
      getViewUrl1(arr) {
        // console.log("这里需要执行", arr);
        if (arr) {
          arr.forEach((item) => {
            item.name = item.FilesName;
            item.url = `${this.baseUrl}admin/file/get?ossFilePath=${item.imgUrl}`;
            item.url2 = item.imgUrl;
          });
          this.fileList = arr;
          console.log(this.fileList, "查看fileList");
        } else {
          this.fileList = [];
        }
      },
      //上传的图片数组
      getViewUrl(arr) {
        let list = [];
        // console.log(arr, "查看这个arr");
        if (arr) {
          arr.forEach((item) => {
            list.push({
              FilesName: item.name,
              imgUrl: item.url2,
              uid: item.uid,
            });
          });
          return JSON.stringify(list);
        }
      },
      //打开上传合同弹窗
      async upLook(obj) {
        this.fileList = [];
        this.innerVisible = true;
        this.loadingwxf = false;
        this.InitObj = obj;
        let params = {
          xmbsm: obj.xmbsm,
        };
        let res = await selectContractPic(params);
        if (res.code == 0) {
          console.log(JSON.parse(res.data.picUrl), "查看res.data.picUrl");
          this.getViewUrl1(JSON.parse(res.data.picUrl));
        } else {
          this.$message.error(res.msg);
        }
      },
      // 关闭上传弹窗
      back() {
        this.innerVisible = false;

      },
      //向后端发送合同照片
      async submit() {
        let ImgUrl = this.getViewUrl(this.fileList);
        let params = {
          contractBaseInfoDtoList: [{ xmbsm: this.InitObj.xmbsm }],
          picUrl: ImgUrl,
        };
        let res = await uploadContract(params);
        if (res.code == 0) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
        this.innerVisible = false;
      },
      async upLoadImg(file, fileList) {
        this.loadingwxf = true;
        if (file.name.toLowerCase().endsWith("pdf")) {
          // 修改符合条件的文件对象的 url 属性
          file.url =
            "https://tse2-mm.cn.bing.net/th/id/OIP-C.or-hk0X7YoPwI6IzdXK7sgHaHa?w=168&h=180&c=7&r=0&o=5&dpr=1.5&pid=1.7";
          file.isShow = "true";
        }

        let res = await this.upload(file, fileList);
      },
      // 上传
      async upload(file, fileList) {
        // 创建一个新的取消令牌
        cancelTokenSource = axios.CancelToken.source();
        let param = new FormData();
        param.append("file", file.raw);

        // 在 axios 请求时传入 signal
        let res;

        res = await uploadFile(param, cancelTokenSource.token);
        // console.log(res, "查看res");

        if (res.code == 0) {
          this.$message.success("上传成功");
          this.loadingwxf = false;
        } else {
          fileList = fileList.filter((item) => item.url2 !== file.url2);
          this.$message.error("上传失败");
          this.loadingwxf = false;
        }
        file.url2 = res.data.url;
        // console.log("file", file);
        this.fileList = fileList;


      },
      // 取消上传请求的示例
      cancelUpload() {
        if (cancelTokenSource) {
          cancelTokenSource.cancel('操作被用户取消');
          // this.$message.error("上传已取消");
          this.loadingwxf = false;
        }
      },

      //发起流转审批列表
      async selectNoApproval() {
        let params = {
          current: this.query.current,
          size: this.query.size,
          ...this.form,
        };

        let res = await selectNoApproval(params);
        if (res.code == 0) {
        
          (this.approvalVoList = res.data.approvalVoList.records),
            (this.defaultSelectList = res.data.approvalNowYearsList);
            this.total=Number(res.data.approvalVoList.total) 

        }
        // console.log("查看获取到的提交列表", this.approvalList);
      },


      async again() {
        // if (this.isProcessing) return; // 如果正在处理，则直接返回
        //   this.isProcessing = true; // 设置为正在处理状态

        let xmbhList = [];
        let xmbsmList = [];
        let noPutXmbhList = [];
        let nopUtXmbsmList = [];
        let phoneList = {};
        console.log(this.tableData2, "this.tableData2");
        console.log(this.tableData3, "this.tableData3");
        const extractData = (dataArray) => {
          dataArray &&
            dataArray.forEach((item) => {
              if (item.operation) {
                if (item.list) {
                  item.list.forEach((subItem) => {
                    xmbhList.push(subItem.xmbh);
                    xmbsmList.push(subItem.xmbsm);
                  });
                } else {
                  xmbhList.push(item.xmbh);
                  xmbsmList.push(item.xmbsm);
                }
              } else {
                if (item.list) {
                  item.list.forEach((subItem) => {
                    noPutXmbhList.push(subItem.xmbh);
                    nopUtXmbsmList.push(subItem.xmbsm);
                  });
                } else {
                  noPutXmbhList.push(item.xmbh);
                  nopUtXmbsmList.push(item.xmbsm);
                }
              }
            });
        };
        // 处理 tableData2 和 tableData3
        extractData(this.tableData2);
        extractData(this.tableData3);
        //去重
        xmbhList = [...new Set(xmbhList)];
        xmbsmList = [...new Set(xmbsmList)];

        //筛选第一次的项目编号和标识码和选择的所没有的但是筛选出来的包括暂不提交的
        let newXmbhList =
          this.xmbhList &&
          this.xmbhList.filter((item) => !xmbhList.includes(item));
        let newXmbsmList =
          this.xmbsmList &&
          this.xmbsmList.filter((item) => !xmbsmList.includes(item));
        console.log(newXmbhList, "newXmbhList");
        console.log(newXmbsmList, "newXmbhList");
        console.log(xmbhList, "xmbhList");
        console.log(xmbsmList, "xmbsmList");

        // 手机号标识
        this.tableData2 &&
          this.tableData2.forEach((item) => {
            if (!item.operation && item.phone) {
              phoneList[item.list[0].xzqbh] = item.phone;
            }
          });

        console.log(this.tableData2, "tableData2");

        this.tableData2 &&
          this.tableData2.forEach((item) => {
            // 检查手机号是否为空并且operation未设置
            if (!item.operation) {
              if (!item.phone) {
                this.$set(item, "validateTip", "手机号不能为空");
              } else {
                this.$set(item, "validateTip", ""); // 清空提示
              }
            } else {
              this.$set(item, "validateTip", ""); // 如果operation被设置，不显示提示
            }
          });

        // 手机号校验
        let params = {
          xmbhList: newXmbhList,
          xmbsmList: newXmbsmList,
          phone: phoneList,
        };

        // 检查tableData2中的validateTip
        let hasError =
          this.tableData2 && this.tableData2.some((item) => item.validateTip);
        if (hasError) {
          this.$message.warning("您还有未填写的项");
          // this.isProcessing = false; // 重置为未处理状态
          return;
        }
        console.log(params, "查看params");

        // 继续执行插入审批的代码
        let res;
        try {
          res = await insertApprovar(params);
          console.log(res);

          if (res.code == 0) {
            this.$message.success({
              message: res.msg,
              offset: 85,
            });
            // this.outerVisible = true;
            this.handleClose3();
            // this.outerVisible = false;
            // this.dialogVisible3=false;
            // this.$emit("handleClose3", false);

            this.outerVisible = true;
          } else {
            this.$message.info({
              message: res.msg,
              offset: 85,
            });
            for (let i = 0; i < res.data.groupApprovalList.length; i++) {
              Object.assign(res.data.groupApprovalList[i], { operation: false });
            }
            this.tableData2 = res.data.groupApprovalList;
          }
        } catch (error) {
          console.error(error);
          // this.$message.error('接口请求失败，请重试');
        } finally {
          // this.isProcessing = false; // 不论成功与否，重置状态标志
        }
      },
      showDetail(xmbh) {
        // this.SET_DIGSTATE(true)
        console.log(xmbh, '查看项目编号')
        // 查看项目详情
        // this.$router.push({
        //       name: "lzsp",
        //       query: {
        //         c: xhbh,
        //         isUpTyp:'before'
        //       }
        //   });

        window.open(window.location.origin + "#/home/lzsp?c=" + xmbh + "&isUpTyp=before");
        //  window.open(window.location.origin + "lzsp?c=" +  xmbh + "&isUpTyp=before", "_blank")


      },
    },
  };

</script>


<style lang="less" scoped>
  .Approve {
    width: 100%;
    height: 100%;
  }

  .tabs {
    width: 100%;
    height: 100%;
    display: flex;
    margin-bottom: 20px;
    justify-content: space-around;

    .itemCls {
      display: block;
      background: #ccc;
    }
  }

  span {
    cursor: pointer;
    /* 鼠标悬停时变成小手 */
  }

  /* 第三个弹窗的样式 */
  /* /deep/.el-dialog__header {
        background-color: #ffffff !important;
        }

        /deep/.el-dialog__title {
        color: black !important;
        font-weight: 500 !important;
        }

        /deep/.el-dialog__header {
        border-bottom: solid 1px #e4e4e4;
        } */

  .upload-tit {
    .file-title {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      font-size: 13px;
      font-weight: 400;
    }
  }

  .upload-container {
    /* padding: 20px; */
    border-bottom: 1px solid #ebebeb;
  }

  .file-card {
    border-radius: 10px;
    background-color: #F9FAFB;
    margin-bottom: 20px;
  }



  .title-text {
    margin-left: 5px;
    font-size: 14px;
    font-weight: bold;
    color: #333;
  }

  .file-item {
    margin-bottom: 10px;
    border-bottom: 1px solid #ebebeb;
    padding-bottom: 10px;
  }

  .file-name {
    display: flex;
    flex-direction: column;
  }

  .file-title-text {
    font-size: 14px;
    font-weight: bold;


  }

  .file-note {
    display: flex;
    font-size: 12px;
    color: #666;
    line-height: 1.5;
  }

  .dialog-footer {
    text-align: right;
    margin-top: 20px;
  }

  .el-button {
    margin-left: 10px;
  }

  .Imgbox {
    width: 100%;
    height: auto;
    display: flex;

    .imageBox {
      position: relative;
      margin-right: 10px;
      width: 100px;
      height: 100px;


      .deleteBtn {
        top: 0;
        right: 0;
        border: solid 1px black;
        width: 25px;
        height: 25px;
        position: absolute;
        z-index: 2000;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 20px;
      }
    }
  }
</style>
